/**
 * Wrapper classes and custom properties for Shape Divider.
 *
 * Shared by edit.jsx and save.jsx so the editor preview and the saved markup
 * cannot drift — a static-save block that computes its wrapper twice is the
 * classic source of "block contains unexpected content" validation errors.
 */

import { resolvePresetValue } from '../../utils/helpers';

/**
 * @param {Object} attributes Block attributes.
 * @return {string} Wrapper class list.
 */
export function getWrapperClasses(attributes) {
  const { shape, flipX, invert, fillType } = attributes;

  return [
    'brandy-shape-divider',
    `is-shape-${shape}`,
    fillType === 'gradient' ? 'has-gradient' : '',
    flipX ? 'is-flipped-x' : '',
    invert ? 'is-inverted' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

/**
 * @param {Object} attributes Block attributes.
 * @return {Object} React style object.
 */
export function getWrapperStyles(attributes) {
  const { height, fillColor } = attributes;

  const styles = {
    '--brandy-shape-divider-height': `${height}px`,
  };

  if (fillColor) {
    styles['--brandy-shape-divider-fill'] = resolvePresetValue(fillColor);
  }

  return styles;
}
